"use client";
import { j as s } from "./jsx-runtime-CJ-St4mQ.mjs";
import { S as e } from "./Separator-CDRYgzW5.mjs";
const n = (r) => {
  const { className: o, orientation: t = "vertical", ...a } = r;
  return /* @__PURE__ */ s.jsx(
    e,
    {
      orientation: t,
      className: "w-px bg-gray-300",
      ...a
    }
  );
};
export {
  n as default
};
